import React from 'react'
import { useTranslation } from 'react-i18next'

// The backdrop is positioned `absolute inset-0` to cover only the
// PageView content area (so sidebar and breadcrumb stay reachable).
// This relies on the closest positioned ancestor being PageView's
// `relative` wrapper at src/components/PageView/PageView.js:21. If
// you reuse this component elsewhere, ensure the parent stack
// provides a positioned ancestor of the area you want covered.
export const CameraBlockedDialog = ({ open, onRetry, isRetrying }) => {
  const { t } = useTranslation()

  if (!open) return null

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="camera-blocked-title"
      aria-describedby="camera-blocked-description"
      className="absolute inset-0 z-20 flex items-center justify-center p-4 bg-gray-500 bg-opacity-75"
    >
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full p-6">
        <div className="sm:flex sm:items-start">
          <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <svg
              className="h-6 w-6 text-red-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2zM3 3l18 18"
              />
            </svg>
          </div>
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 id="camera-blocked-title" className="text-lg leading-6 font-medium text-gray-900">
              {t('generate_shipment.camera_blocked_dialog.title')}
            </h3>
            <div id="camera-blocked-description" className="mt-2">
              <p className="text-sm text-gray-700">
                {t('generate_shipment.camera_blocked_dialog.description')}
              </p>
              <p className="mt-3 text-sm font-medium text-red-700">
                {t('generate_shipment.camera_blocked_dialog.instruction')}
              </p>
            </div>
          </div>
        </div>
        <div className="mt-5 sm:mt-6 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            onClick={onRetry}
            disabled={isRetrying}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isRetrying
              ? t('generate_shipment.camera_blocked_dialog.detecting')
              : t('generate_shipment.camera_blocked_dialog.retry_button')}
          </button>
        </div>
      </div>
    </div>
  )
}
